import React from 'react';
import AppHeader from '../components/AppHeader';
import LandingFooter from '../components/Landing/LandingFooter';

// Reusable "coming soon" shell for menu items with no built feature yet
// (docs/DECISIONS.md, "Persistent left-side student navigation +
// light-theme visual fix") - one component instead of six near-identical
// page files for My Availability, My Roadmap, Smart Study Plan, Previous
// Year Papers, Mock Tests, and Preferences.
export default function PlaceholderPage({ title, icon: Icon, description }) {
  return (
    <div className="min-h-screen bg-white text-navy flex flex-col">
      <AppHeader subtitle={title} />

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center space-y-4 rounded-card border border-gray-200 bg-white shadow-brand-md p-8">
          {Icon && (
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-blue/10 text-brand-blue">
              <Icon size={28} />
            </span>
          )}
          <h1 className="text-lg font-display font-bold text-navy">{title}</h1>
          <p className="text-sm text-text-slate">{description}</p>
          <span className="inline-flex items-center rounded-full bg-surface-light px-3 py-1 text-xs font-semibold uppercase tracking-wide text-brand-blue">
            Coming soon
          </span>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
}
